<template>
  <div class="description">
    <iframe frameborder="0" ref="iframe"></iframe>
    <img :src="iframeImageUrl" v-if="iframeImageUrl" ref="img" alt="" class="qr-code-touchable-image">
  </div>
</template>

<script>
  /*  import context from "@/utils/context";

    (async () => {
      const parse = (key, dft = "null") => {
        try {
          return JSON.parse(document.getElementById(key).value || dft);
        } catch (e) {
          return JSON.parse(dft);
        }
      };

      const sdkConfig = parse("sdkConfig");

      if (sdkConfig) {
        if (sdkConfig.jsApiList.includes("onMenuShareTimeline")) {
          sdkConfig.jsApiList.push("onMenuShareTimeline");
        }
        if (sdkConfig.jsApiList.includes("onMenuShareAppMessage")) {
          sdkConfig.jsApiList.push("updateAppMessageShareData");
        }
      }

      await context.ready({
        wxConfig: sdkConfig
      });
    })();*/

  // ios中,长按iframe内的二维码无法调起识别,解决方式如下
  // 通过事件代理拦截iframe内所有图片的touch事件,获取其src
  // 然后设置一个覆盖全屏的图片即可(透明度设置为0.01)

  function catchImageTouch(el, opt = {}) {
	const onStart = e => {
	  if (e.target.tagName.toLowerCase() !== 'img') return;
	  opt.onStart(e.target.src);
	};
	const onEnd = e => {
	  if (e.target.tagName.toLowerCase() !== 'img') return;
	  opt.onEnd(e.target.src);
	};
	const onMove = e => {
	  if (e.target.tagName.toLowerCase() !== 'img') return;
	  opt.onMove(e.target.src);
	};
	el.removeEventListener('touchstart', onStart);
	el.addEventListener('touchstart', onStart);
	el.removeEventListener('touchmove', onMove);
	el.addEventListener('touchmove', onMove);
	el.removeEventListener('touchend', onEnd);
	el.addEventListener('touchend', onEnd);
  }

  export default {
	name: 'description',
	props: {
	  data: String
	},
	components: {},
	data() {
	  return {
		touchTime: new Date(),
		urls: [],
		iframeImageUrl: ''
	  };
	},
	created() {
	},
	methods: {
	  onTouchIframeImage(url) {
		this.touchHasMoved = false;
		this.touchTime = new Date();
		this.iframeImageUrl = url;
	  },
	  onMoveIframeImage() {
		console.log('touch move');
		this.touchHasMoved = true;
	  },
	  onLeaveIframeImage(url) {
		/*		if ((new Date() - this.touchTime) < 300 && !this.touchHasMoved) {
                  console.log('preview image', url);
                  context.previewImage({
                    urls: this.urls,
                    current: url
                  }).then(console.log);
                }*/
		this.iframeImageUrl = '';
	  },

	  initHeight() {
		const frame = this.$refs['iframe'];

		const frameWin = this.$refs['iframe'].contentWindow;
		const frameDoc = frameWin.document;

		catchImageTouch(frameDoc.body, {
		  onStart: this.onTouchIframeImage,
		  onMove: this.onMoveIframeImage,
		  onEnd: this.onLeaveIframeImage
		});
		frameDoc.body.innerHTML = this.description;

		const checkHeight = () => {
		  const height = frameDoc.getElementById('content').clientHeight || frameDoc.body.scrollHeight;
		  console.log(' description height is ', height);
		  frame.height = height + 20;
		  this.urls = [...frameDoc.images].map(it => it.src);
		};

		setTimeout(checkHeight, 20);

		// 没有设置高度的图片会撑高iframe,导致出现滚动条
		frameDoc.body.addEventListener('load', e => {
		  if (e.target.nodeName.toLowerCase() === 'img') {
			checkHeight();
		  }
		}, true);
	  }
	},
	computed: {
	  description() {
		return `<style>
body{
        margin: 0;padding: 0;
        }
        img{
        width: 100%;
        }
        body::-webkit-scrollbar{
        display: none;
        }
</style>
<div id="content">${this.data}</div>
`;
	  }
	},
	watch: {
	  description: {
		async handler() {
		  if (!this.$refs['iframe']) {
			await this.$utils.sleep(50);
		  }
		  this.initHeight();
		}, immediate: true
	  }
	}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .description {
    padding: 0 10px !important;

    iframe {
      width: 100%;
    }

    .qr-code-touchable-image {
      opacity: 0.01;
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
    }
  }
</style>
